// extracted by mini-css-extract-plugin
module.exports = {"container":"cG-z","productName":"dG-z","modal":"eG-z","dimensions":"fG-z","recipientEmail":"gG-z","lowStock":"hG-z","recommendedFit":"iG-z"};